/* Announcement Section  */
import styled from 'styled-components';

export const AnnouncementWrapper = styled.div`
.announcement-image {
    width: 150px;
    height: 90px;
    padding: 10px;
    border-radius: 4px;
}

.announcements-control {
    margin-bottom: 0px;
}

.announcements-control li {
    background-color: #0058b9 !important;
}

.announcements {
    padding: 5px 5px 5px 5px;
    margin-right: 4px;
    text-align: center;
    width: 90px;
}

.announcement-media p {
    font-size: 13px;
    line-height: 1.5;
    font-family: roboto, SFUIDisplay-Regular, --apple-system;
}

.announcement-media h6 {
    font-size: 18px;
    font-weight: bold;
    font-family: roboto, SFUIDisplay-Regular, --apple-system;
}

.carousel-announcement {
    padding: 0px 28px 10px 28px;
}
.carousel-inner{
    padding-top: 0px !important;
    padding-right: 28px !important;
    padding-bottom: 10px !important;
    padding-left: 28px !important;

}

.announcements-sec .card-body h5 {
    font-size: 16px;
}`;